<template>
    <div class="abstract-submission">
        <div class="header">
            <span><a href="/">{{ $t('submission.header.title') }}</a></span>
        </div>
        <div class="submission-content">
            <div class="submission-container">
                <div class="description-container">
                    <p style="font-size:18px; margin:10px 0;"><strong> {{ $t('submission.desc.title') }} </strong></p>
                    <p style="font-size:16px; margin:10px 0;"><strong> {{ $t('submission.desc.guidelines_title') }} </strong></p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.guidelines_content1') }} </p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.guidelines_content2') }} </p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.guidelines_content3') }} </p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.guidelines_content4') }} </p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.guidelines_content5') }} </p>

                    <p style="font-size:16px; margin:10px 0;"><strong> {{ $t('submission.desc.awards_title') }}
                        </strong></p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.awards_content1') }} </p>
                    <p style="font-size:13px; line-height: 1.6;"> {{ $t('submission.desc.awards_content2') }} </p>
                    <p style="font-size:13px; line-height: 1.6;" v-html="$t('submission.desc.awards_content3')"></p>
                    <p><br></p>
                </div>

                <h2 class="form-title">{{ $t('submission.title') }}</h2>

                <div class="submisson-form">
                    <el-form :model="form" :rules="rules" ref="formRef" label-position="left" :label-width="140">

                        <div class="form-items">

                            <!-- Paper Details -->
                            <div class="form-warp">
                                <p class="item-title paper-details">{{ $t('submission.form.paperDetails.title') }}</p>
                                <!-- <p class="tip"></p> -->
                            </div>
                            <!-- <el-form-item :label="$t('submission.form.paperDetails.conferenceName.title')">
                                <p>{{ $t('submission.form.paperDetails.conferenceName.content') }}</p>
                            </el-form-item> -->
                            <!-- <el-form-item :label="$t('submission.form.paperDetails.deadline.title')">
                                <p>{{ $t('submission.form.paperDetails.deadline.content') }}</p>
                            </el-form-item> -->
                            <el-form-item :label="$t('submission.form.paperDetails.research.title')" required>
                                <el-input v-model="form.research"
                                    :placeholder="$t('submission.form.paperDetails.research.placeholder')"></el-input>
                            </el-form-item>
                            <div class="upload-section">
                                <el-form-item :label="$t('submission.form.paperDetails.abstract.title')" required class="upload-item">
                                    <el-upload class="abstract-upload" v-model:file-list="fileList"
                                        :http-request="customUpload" :on-remove="handleRemove" :before-upload="beforeUpload"
                                        :on-change="handleChange" drag multiple :file-list="fileList">
                                        <!-- <el-icon class="el-icon--upload"><upload-filled /></el-icon> -->
                                        <template #tip>
                                            <div class="el-upload__tip">
                                                WORD <span style="color: #ff7d13;">(Required)</span>
                                            </div>
                                        </template>
                                        <img src="@/assets/doc.png" alt="">
                                        <div class="el-upload__text">
                                            {{ $t('submission.form.paperDetails.abstract.placeholder') }}
                                        </div>
                                    </el-upload>
                                </el-form-item>
                                
                                <el-form-item :label="$t('submission.form.paperDetails.poster.title')" class="upload-item" required>
                                    <el-upload class="poster-upload" v-model:file-list="posterFileList"
                                        :http-request="customPosterUpload" :on-remove="handlePosterRemove" :before-upload="beforePosterUpload"
                                        :on-change="handlePosterChange" drag multiple :file-list="posterFileList">
                                        <template #tip>
                                            <div class="el-upload__tip">
                                                PPT/JPG <span style="color: #ff7d13;">(Required)</span>
                                            </div>
                                        </template>
                                        <img src="@/assets/poster.svg" alt="">
                                        <div class="el-upload__text">
                                            {{ $t('submission.form.paperDetails.poster.placeholder') }}
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </div>

                            <!-- 下载海报模板 -->
                            <div class="form-warp download-poster">
                                <el-button type="primary" @click="downloadTemplate">{{ $t('submission.form.posterTemplate.download') }}</el-button>
                            </div>

                            <!-- Author Info -->
                            <div class="form-warp">
                                <p class="item-title author-info">{{ $t('submission.form.authorInfo.title') }}</p>
                                <p class="tip" v-if="!isAuthorComplete">{{ $t('submission.form.authorInfo.tip') }}</p>
                            </div>
                            <div v-for="(author, index) in form.authors" :key="index" class="author-group">
                                <div class="author-header">
                                    <!-- <span>{{ $t('submission.form.authorInfo.authorIndex', { index: index + 1 }) }}</span> -->
                                    <el-button v-if="index > 0" type="text" class="remove-btn"
                                        @click="removeAuthor(index)" style="color: #f56c6c; font-weight: normal;">
                                        <el-icon style="margin-right: 5px;">
                                            <RemoveFilled />
                                        </el-icon>{{ $t('submission.form.authorInfo.removeAuthor') }}
                                    </el-button>
                                </div>
                                <el-form-item :label="$t('submission.form.authorInfo.name.title')" required
                                    :prop="`authors.${index}.authorName`" :show-message="false">
                                    <el-input v-model="author.authorName"
                                        :placeholder="$t('submission.form.authorInfo.name.placeholder')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('submission.form.authorInfo.affiliation.title')" required
                                    :prop="`authors.${index}.affiliation`" :show-message="false">
                                    <el-input v-model="author.affiliation"
                                        :placeholder="$t('submission.form.authorInfo.affiliation.placeholder')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('submission.form.authorInfo.mobile.title')" required
                                    :prop="`authors.${index}.mobile`" :show-message="false">
                                    <div class="mobile-input">
                                        <vue3-country-intl v-model="author.countryCode" type="phone"
                                            :default-value="+86" :placeholder="$t('register.countryCodePlaceholder')"
                                            class="country-selector" :showAreaCode="true" :showLabelImg="true"
                                            :searchAble="true" />
                                        <el-input v-model="author.mobile"
                                            :placeholder="$t('submission.form.authorInfo.mobile.placeholder')"></el-input>
                                    </div>
                                </el-form-item>
                                <el-form-item :label="$t('submission.form.authorInfo.email.title')" required
                                    :prop="`authors.${index}.email`" :show-message="false">
                                    <el-input v-model="author.email"
                                        :placeholder="$t('submission.form.authorInfo.email.placeholder')"></el-input>
                                </el-form-item>
                            </div>

                            <!-- 添加作者 -->
                            <!-- <el-button type="primary" class="add-author-btn" @click="addAuthor"
                                style="color: #1f68ac; font-weight: normal;">
                                <el-icon style="margin-right: 5px;">
                                    <CirclePlusFilled />
                                </el-icon>{{ $t('submission.form.authorInfo.addAuthor') }}
                            </el-button> -->

                            <!-- Shipping Information -->
                            <!-- <div class="form-warp">
                                <p class="item-title shipping-info">{{ $t('submission.form.shippingInfo.title') }}</p>
                                <p class="tip" v-if="!isShippingComplete">{{ $t('submission.form.shippingInfo.tip') }}
                                </p>
                            </div>
                            <el-form-item :label="$t('submission.form.shippingInfo.name.title')"
                                :prop="`shippingInfo.name`" :show-message="false">
                                <el-select v-model="form.shippingInfo.name"
                                    :placeholder="hasAuthorsWithName ? $t('submission.form.shippingInfo.name.placeholder') : $t('submission.form.shippingInfo.name.disabledMessage')"
                                    :disabled="!hasAuthorsWithName">
                                    <el-option v-for="(author, index) in form.authors" :key="index"
                                        :label="author.authorName" :value="author.authorName"
                                        :disabled="!author.authorName" />
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('submission.form.shippingInfo.address.title')"
                                :prop="`shippingInfo.address`" :show-message="false">
                                <el-input v-model="form.shippingInfo.address"
                                    :placeholder="$t('submission.form.shippingInfo.address.placeholder')"></el-input>
                            </el-form-item> -->

                        </div>
                        <div class="submit-section">
                            <el-button type="primary" @click="submitForm" class="submit-btn" :loading="loading">
                                {{ $t('common.submit') }}
                            </el-button>
                        </div>
                    </el-form>
                </div>

            </div>
        </div>
        <Footer />
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Document, UploadFilled, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'
import { submitAbstract } from '@/api/submission'
import { uploadAbstractFile, uploadPosterFile } from '@/api/submission'
import Footer from '@/components/Footer'

const i18n = useI18n()
const { t, locale } = i18n

const form = ref({
    research: '',
    abstractFile: null,
    authors: [{
        authorName: '',
        affiliation: '',
        countryCode: '+86',
        mobile: '',
        email: ''
    }],
    // shippingInfo: {
    //     name: '',
    //     address: ''
    // }
})

const formRef = ref()
const loading = ref(false)

// 计算是否有作者姓名
const hasAuthorsWithName = computed(() => {
    return form.value.authors.some(author => author.authorName && author.authorName.trim() !== '')
})
const isAuthorComplete = computed(() => {
    const value = form.value.authors;
    if (value.length === 0) return false;
    return value.every(author => author.authorName && author.affiliation && author.mobile && /^\d{11}$/.test(author.mobile) && author.email && /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(author.email));
});
const isShippingComplete = computed(() => {
    return form.value.shippingInfo.name && form.value.shippingInfo.address;
});

// 表单验证规则
const rules = {
    research: [
        { required: true, message: t('common.required'), trigger: 'blur' }
    ],
    authors: [
        {
            type: 'array',
            required: true,
            message: t('submission.form.authorInfo.atLeastOne'),
            trigger: 'change'
        },
        {
            validator: (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error(t('submission.form.authorInfo.atLeastOne')))
                } else {
                    let errors = []
                    value.forEach((author, index) => {
                        if (!author.authorName) errors.push(`Author ${index + 1} name is required`)
                        if (!author.affiliation) errors.push(`Author ${index + 1} affiliation is required`)
                        if (!author.mobile || !/^\d{11}$/.test(author.mobile)) errors.push(`Author ${index + 1} mobile is invalid`)
                        if (!author.email || !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(author.email)) errors.push(`Author ${index + 1} email is invalid`)
                    })
                    if (errors.length > 0) {
                        callback(new Error(errors.join('; ')))
                    } else {
                        callback()
                    }
                }
            },
            trigger: 'change'
        }
    ],
    // 'shippingInfo.name': [
    //     { required: true, message: t('common.required'), trigger: 'change' }
    // ],
    // 'shippingInfo.address': [
    //     { required: true, message: t('common.required'), trigger: 'blur' }
    // ]
}

// 提交表单
const submitForm = async () => {
    await formRef.value.validate(async (valid) => {
        if (!valid) return
        if (tempPaths.value.length === 0) {
            ElMessage.warning(t('submission.form.paperDetails.abstract.tip'))
            return
        }
        loading.value = true
        try {
            const formData = new FormData()
            formData.append('research', form.value.research)
            tempPaths.value.forEach(path => {
                formData.append('temp_paths', path)
            })
            posterTempPaths.value.forEach(path => {
                formData.append('poster_temp_paths', path)
            })
            form.value.authors.forEach((author, index) => {
                formData.append(`authors[${index}][authorName]`, author.authorName)
                formData.append(`authors[${index}][affiliation]`, author.affiliation)
                formData.append(`authors[${index}][countryCode]`, author.countryCode)
                formData.append(`authors[${index}][mobile]`, author.mobile)
                formData.append(`authors[${index}][email]`, author.email)
            })
            // formData.append('shippingInfo[name]', form.value.shippingInfo.name)
            // formData.append('shippingInfo[address]', form.value.shippingInfo.address)
            const response = await submitAbstract(formData, (progress) => {
                uploadProgress.value = progress
            })
            if (response.success) {
                ElMessage.success(t('common.success'))
                formRef.value.resetFields()
                form.value.authors = [{ authorName: '', affiliation: '', countryCode: '+86', mobile: '', email: '' }]
                form.value.shippingInfo = { name: '', address: '' }
                fileList.value = []
                posterFileList.value = []
                tempPaths.value = []
                posterTempPaths.value = []
            } else {
                ElMessage.error(response.message || t('common.error'))
            }
        } catch (error) {
            // Enhanced error handling
            if (error.response) {
                ElMessage.error(error.response.data.message || t('common.error'))
            } else {
                ElMessage.error(t('common.error'))
            }
        } finally {
            loading.value = false
            uploadProgress.value = 0
        }
    })
}

const fileList = ref([])
const posterFileList = ref([])

// 限制仅上传 WORD 格式（.doc 和 .docx）
const beforeUpload = (file) => {
    const isWord = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isWord) {
        ElMessage.warning(t('submission.form.paperDetails.abstract.tip'))
        return false
    }
    if (!isLt10M) {
        ElMessage.warning('File size cannot exceed 10MB')
        return false
    }
    return true
}

// 文件状态变化时回调
const handleChange = (uploadFile, uploadFileList) => {
    fileList.value = uploadFileList
    form.value.abstractFile = uploadFile.raw
}

// 文件移除时回调
const tempPaths = ref([])
const posterTempPaths = ref([])
const uploadProgress = ref(0)
const fileToPathMap = ref(new Map()) // 添加文件到路径的映射
const posterFileToPathMap = ref(new Map()) // 海报文件到路径的映射

const customUpload = async (uploadFile) => {
    try {
        uploadProgress.value = 0
        const response = await uploadAbstractFile(uploadFile.file, (progress) => {
            uploadProgress.value = progress
        })
        if (response.success) {
            // 将文件与临时路径关联
            response.temp_paths.forEach(path => {
                tempPaths.value.push(path)
                fileToPathMap.value.set(uploadFile.file.uid, path)
            })
            uploadFile.onSuccess(response)
        } else {
            uploadFile.onError(response.message)
        }
    } catch (error) {
        uploadFile.onError(error)
    }
}

const handleRemove = (file) => {
    // 根据文件uid找到对应的临时路径并移除
    const tempPath = fileToPathMap.value.get(file.uid)
    if (tempPath) {
        tempPaths.value = tempPaths.value.filter(path => path !== tempPath)
        fileToPathMap.value.delete(file.uid)
    }
}

// 海报文件上传验证
const beforePosterUpload = (file) => {
    const isPPT = file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
    const isValidType = isPPT || isJPG
    const isLt20M = file.size / 1024 / 1024 < 20
    if (!isValidType) {
        ElMessage.warning('Only PPT and JPG files are allowed')
        return false
    }
    if (!isLt20M) {
        ElMessage.warning('File size cannot exceed 20MB')
        return false
    }
    return true
}

// 海报文件状态变化时回调
const handlePosterChange = (uploadFile, uploadFileList) => {
    posterFileList.value = uploadFileList
}

// 海报文件自定义上传
const customPosterUpload = async (uploadFile) => {
    try {
        uploadProgress.value = 0
        const response = await uploadPosterFile(uploadFile.file, (progress) => {
            uploadProgress.value = progress
        })
        if (response.success) {
            // 将文件与临时路径关联
            response.temp_paths.forEach(path => {
                posterTempPaths.value.push(path)
                posterFileToPathMap.value.set(uploadFile.file.uid, path)
            })
            uploadFile.onSuccess(response)
        } else {
            uploadFile.onError(response.message)
        }
    } catch (error) {
        uploadFile.onError(error)
    }
}

// 海报文件移除时回调
const handlePosterRemove = (file) => {
    // 根据文件uid找到对应的临时路径并移除
    const tempPath = posterFileToPathMap.value.get(file.uid)
    if (tempPath) {
        posterTempPaths.value = posterTempPaths.value.filter(path => path !== tempPath)
        posterFileToPathMap.value.delete(file.uid)
    }
}

// 下载海报模板
const downloadTemplate = () => {
    window.open( process.env.VUE_APP_API_URL + '/uploads/the_7th_ICAC_Conference.pptx', '_blank')
}

// 添加作者方法
const addAuthor = () => {
    form.value.authors.push({
        authorName: '',
        affiliation: '',
        countryCode: '+86',
        mobile: '',
        email: ''
    })
}

// 删除作者方法
const removeAuthor = (index) => {
    form.value.authors.splice(index, 1)
}

// 文件预览时回调
const handlePreview = (file) => {
    // 如果需要预览功能，可以在这里实现
    console.log('Preview file:', file.name)
}

onMounted(() => {
    localStorage.setItem('language', 'en')
    locale.value = 'en'
})

document.title = t('submission.title')

</script>


<style scoped lang="scss">
.header {
    position: relative;
    width: 100%;
    height: 80px;
    display: flex;
    background-color: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(6, 0, 1, 0.11);
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;

    letter-spacing: 3px;

    a {
        // 这里不需要重复的样式
        color: #333;
        font-weight: bold;
    }
}


.header {
    a {
        text-decoration: none;
        font-size: 18px;
        color: #333;
        font-weight: bold;

        &:hover {
            color: #62a8ea
        }
    }
}

.submission-content {
    width: 100%;
    padding: 30px 0;
}

.submission-container {
    max-width: 1200px;
    margin: 0 auto;

    .description-container {
        max-height: 300px;
        overflow-y: auto;
        padding: 15px;
        // border: 1px solid #e8e8e8;
        // border-radius: 8px;
        // background-color: #fafafa;
        margin-bottom: 20px;

        p {
            a {
                text-decoration: none !important;
            }
        }


        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;

            &:hover {
                background: #a8a8a8;
            }
        }
    }

    .form-title {
        background: linear-gradient(180deg, #fff, #f4f4f4);
        border-radius: 5px 5px 0 0;
        border: 1px solid #e3e3e3;
        position: relative;
        padding: 10px 0;

        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 300;
        letter-spacing: 2px;
        text-align: center;
        color: #666;
    }

    .submisson-form {
        padding: 20px;

        .form-items {
            margin-bottom: 20px;
        }

        :deep(.el-form-item__label) {
            line-height: normal;
        }

        .form-warp {
            margin-bottom: 15px;
            position: relative;

            &::after {
                content: '';
                left: 0;
                top: 30px;
                position: absolute;
                width: 200px;
                height: 1px;
                background-color: #399eb8;
            }

            .item-title {
                font-size: 16px;
                font-weight: 700;
                margin-right: 20px;
                margin-bottom: 5px;
                color: #333;
                display: inline-block;
            }

            .tip {
                display: inline-block;
                color: #f56c6c;
                font-size: 12px;

                &::before {
                    content: "*";
                    color: #f56c6c;
                    margin-right: 5px;
                }
            }

        }

        :deep(.el-input__wrapper),
        :deep(.el-select__wrapper) {
            border-radius: 5px;
            border: 1px solid #e8e8e8;
            transition: border-color 0.3s;
            box-shadow: none;
            height: 40px;

            &:hover {
                border-color: #c0c4cc;
            }

            &.is-focus {
                border-color: #409eff;
                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
            }
        }

        :deep(.el-input__inner) {
            font-size: 14px;
            padding: 12px 0 12px 0;
            height: 36px;
        }

        // 上传区域布局
        .upload-section {
            display: flex;
            gap: 20px;
            align-items: flex-start;
            
            .upload-item {
                flex: 1;
                margin-bottom: 0;
            }
        }

        // 摘要\海报上传
        .abstract-upload,
        .poster-upload {

            :deep(.el-upload-dragger) {
                width: 160px;
                height: 160px;

                padding: 30px;

                img {
                    width: 64px;
                    height: 64px;
                }

                .el-upload__text {
                    font-size: 12px;
                    line-height: 20px;
                    text-overflow: ellipsis;
                    text-align: center;
                }

            }

            .el-upload__tip {
                color: #333;
                font-size: 11px;
                margin-top: 2px;
                text-align: center;
                max-width: 160px;
            }
            :deep(.el-upload-list) {
                font-size: 11px;
                max-width: 160px;
            }
        }


        // 移动电话输入样式
        .mobile-input {
            display: flex;
            gap: 2px;
            align-items: center;
            width: 450px;

            // .country-code-select {
            //     width: 140px;
            //     margin-right: 10px;
            // }
            :deep(.vue-country-intl-inputer) {
                :deep(.country-intl-input) {
                    border-radius: 4px !important;
                    border: 1px solid #dcdfe6 !important;
                    transition: border-color 0.3s;
                    font-size: 14px;
                    padding: 12px 15px;
                    height: 40px;

                    &:hover {
                        border-color: #c0c4cc;
                    }

                    &:focus {
                        border-color: #409eff;
                        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                        outline: none;
                    }
                }

                .country-intl__dropdown {
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                }

                .country-intl-label {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    height: calc(100% - 1px);
                    text-align: center;
                    border-bottom: 1px solid #dcdfe6;
                    /* 恢复下边框 */
                }

                .country-intl-label-text {
                    line-height: 1;
                }
            }

            .el-input {
                flex: 1;
            }
        }

        // 作者信息
        .author-group {
            margin-bottom: 20px;
        }

        .author-group:not(:last-child) {
            // border-bottom: 1px solid #dcdfe6;
            padding-bottom: 20px;
        }

        .author-header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;
            font-weight: bold;
            color: #f56c6c;
        }

        .remove-btn {
            color: #f56c6c;
            font-size: 16px;
        }

        .add-author-btn {
            margin-top: 10px;
            margin-bottom: 30px;
            background: none;
            border: none;
            color: #409eff;
            font-size: 16px;
            padding: 0;
        }

        // 提交按钮
        .submit-section {
            margin-top: 32px;
            text-align: center;

            :deep(.el-form-item__content) {
                display: flex;
                justify-content: center;
            }

            .submit-btn {
                min-width: 130px;
                height: 44px;
                font-size: 16px;
                font-weight: 500;
                border-radius: 4px;
                border: none;
                transition: all 0.3s;
                background-color: #2aa2d1;

                &:hover {
                    background-color: #2aaadc;
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .header {
        padding: 20px;
        text-align: center;
        letter-spacing: 1px;
    }

    .submission-content {
        padding: 20px;
    }

    .submission-container {
        padding: 0;
    }

    .form-title {
        font-size: 18px;
        padding: 8px 0;
    }

    .submisson-form {
        padding: 15px;

        .upload-section {
            flex-direction: column;

            .abstract-upload,
            .poster-upload {
                :deep(.el-upload-dragger) {
                    width: 120px;
                    height: 120px;
                    padding: 17px;

                    img {
                        width: 50px;
                        height: 50px;
                    }

                }

                :deep(.el-upload__tip),
                :deep(.el-upload-list) {
                    max-width: 120px;
                    font-size: 10px;
                }
            }
        }
    }

    .form-warp {
        margin-bottom: 10px;

        &::after {
            top: 27px !important;
        }
    }

    .item-title {
        font-size: 15px;
    }

    .el-form-item {
        align-items: center;

        :deep(.el-form-item__label) {
            font-size: 14px;
            width: 100px !important;
        }

        :deep(.el-form-item__content) {
            font-size: 14px;
            line-height: 20px;
        }
    }

    .mobile-input {
        flex-direction: column;
        gap: 10px;

        .country-selector {
            width: 100%;
        }
    }

    .add-author-btn,
    .submit-btn {
        width: 100%;
    }
}
</style>
